module.exports = __webpack_public_path__ + "static/s5-1-carrying-d-9cb9fa474aa4c06f86672e8db157ee19.jpg";